import { Button } from "@/components/ui/button";
import { useLineConnection } from "@/hooks/useLineConnection";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";

export const LineLinkPage = () => {
  const navigate = useNavigate();
  const { startLineConnection, isLinkProcessing } = useLineConnection();

  const handleLineConnection = async () => {
    try {
      await startLineConnection();
    } catch (error) {
      console.error("LINE connection failed:", error);
      toast.error("LINE連携の開始に失敗しました");
    }
  };

  const handleSkip = () => {
    navigate("/");
  };

  return (
    <>
      <Helmet>
        <title>LINE連携 | refloop</title>
      </Helmet>

      <div className="flex min-h-screen flex-col bg-white px-4 py-8">
        <div className="mx-auto w-full max-w-md space-y-6">
          {/* ロゴ */}
          <div className="text-center">
            <img src="/logo-type.svg" alt="refloop" className="mx-auto h-8 opacity-70" />
          </div>

          {/* 説明文・ボタン・画像 */}
          <div className="flex flex-col items-center space-y-6">
            {/* 説明文とボタンのコンテナ */}
            <div className="inline-flex flex-col items-stretch gap-6">
              {/* 説明文 */}
              <p className="text-center text-sm text-gray-600">
                LINE連携を完了させてください！
                <br />
                毎週あなたにぴったりな
                <br />
                おすすめスポットを受け取りましょう！
                <br />
                通知設定からあなたのお休みに合わせて
                <br />
                配信する曜日を調整できます！
              </p>

              {/* LINE連携ボタン */}
              <Button
                onClick={handleLineConnection}
                disabled={isLinkProcessing}
                className="bg-[#06C755] text-white hover:bg-[#06C755]/90 disabled:opacity-50"
              >
                {isLinkProcessing ? "処理中..." : "LINE連携する"}
              </Button>
            </div>

            {/* LINE配信イメージ */}
            <img
              src="/static/line/line-delivery-preview.png"
              alt="LINE配信イメージ"
              className="h-80 w-auto"
            />
          </div>

          {/* スキップボタン */}
          <div className="text-center">
            <button
              type="button"
              onClick={handleSkip}
              className="text-sm text-gray-600 underline hover:text-gray-800"
            >
              スキップ
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
